<div>
<p>We believe in Club Walkers enjoying their walk in safety and comfort. But this can be a
double-edged sword; if you are inadequately prepared for a given walk you are a danger to
OTHERS in your walking group as well as a danger to YOURSELF.</p>
<p>The best thing you can do for your own safety is to be properly equipped.
</p>

<ul class="simpleList">
  <li><strong>Membership Card:</strong> Carry it with you on all walks - and ensure the
  additional information, (Date of Birth, Ailments and allergies, Disabilities, Any long term
  medical treatment(s), Blood Group), is up to date.</li>

  <li><strong>Insulation:</strong> Modern fibres such as Polartec fleece have, to a large
  extent, replaced natural fibres.</li>

  <li><strong>Boots:</strong> Need to be comfortable yet robust, give support for the ankles
  and a sound grip with the ground. Modem composition soles with good tread are best for most
  conditions, e.g. Vibram or Contagrip.</li>

  <li><strong>Socks:</strong> Loop pile thermal in winter, Coolmax in summer and, if you
  prefer, a thin lining sock. Nylon or cotton may cause discomfort.</li>

  <li><strong>Gaiters:</strong> Strongly recommended for rough terrain, especially when it is
  wet or snowing.</li>

  <li><strong>Trousers:</strong> Jeans are hot in warm weather and a positive hypothermia
  killer in cold, wet weather. Do NOT wear them please. It is sensible to wear trousers that
  are windproof, that dry easily and are loose fitting, and comfortable.</li>

  <li><strong>Thermal Underwear:</strong> These are strongly recommended for both ladies and
  gentlemen, especially in winter months. You know it makes sense. Again the choice is
  between natural fibres like wool and man-made thermal fibres like those used in Helly
  Hansen and other similar underwear.</li>

  <li><strong>Shirt(s) Jumpers:</strong> Suitably warm! Not necessarily two inches thick. It
  is far better to go for a number of layers, extra length to cover the small of the back
  etc.</li>

  <li><strong>Body Warmers:</strong> Highly recommended.</li>

  <li><strong>Gloves/Mitts:</strong> Two pairs are better than one, again the layer
  principle. A waterproof pair or waterproof overgloves are necessary for wet weather.</li>

  <li><strong>Hats:</strong> 50%+ of body heat is lost through the head. Get a hat and have
  it with you on ALL walks - it can get surprisingly cold on the tops even on a hot summer's
  day.</li>

  <li><strong>Waterproofs:</strong> Do ensure that you are carrying/wearing outer shell
  garments (Jackets and Overtrousers) which ARE waterproof Some of the weather we walk in has
  to be experienced to be believed. We do not want a case of hypothermia occurring due to a
  member's lack of attention to these major clothing items, or worse, leaving them behind
  just because we have perhaps enjoyed a recent spell of good weather.<br />
  Waterproof jackets and overtrousers are also useful windproof garments, which will help
  reduce the wind-chill factor.</li>

  <li><strong>Rucksacks:</strong> A daysack which is large enough to contain all your gear
  for the day's walk.<br />
  Remember to put a large, heavy gauge polythene bag in it to help act as a waterproof liner.
  (These can be obtained custom made).</li>

  <li><strong>Maps:</strong> It is preferable for each member to carry a map of the area for
  the walk of that day. A waterproof see-through cover for your map is sound sense for wet
  days. (Laminated maps can now be obtained).<br />
  Part of the enjoyment of any walk is to relate what is seen "on the ground" with the way it
  is represented on the map; an active interest in map reading is worth cultivating. It could
  some day save a life - perhaps your own!</li>

  <li><strong>Compass:</strong> Carry one and know how to use it. The protractor type, like
  the Silva compass, is a valuable item to be used in conjunction with the map. Modern
  technology has now produced the GPS, which some members may find useful.</li>

  <li><strong>Whistle:</strong> A must! The emergency procedure when in distress is six
  blasts per minute followed by a minute's silence. Repeat even after you hear a response -
  which is three blasts during your minute's silence - until visual contact is clearly made.
  The orange plastic ones without a 'pea' are best value.</li>

  <li><strong>Food:</strong> Adequate for the day, high in carbohydrates for readily
  available energy. Emergency rations, like Mars bars, will be ADDITIONAL to your day's
  rations.</li>

  <li><strong>Liquids:</strong> De-hydration is the problem on any day walk or longer. Carry
  a hot drink in a thermos flask for cold weather and <i>PLENTY</i> of water - flavoured or
  plain, for hot weather. Coffee and tea are diuretics and NOT recommended.<br />
  WARNING: - Alcohol is dehydrating and helps the onset of hypothermia.</li>

  <li><strong>First Aid Kit:</strong> In addition <strong>to some plasters</strong> for
  blisters, a minimum kit will contain painkillers like Paracetamol and at least one large
  wound dressing (a sterile pad attached to a bandage). We all carry something extra that we,
  as individuals consider necessary in our personal or group first-aid kit.</li>

  <li><strong>Watch:</strong> Vital! Do cheek that it is in good working condition with a
  secure strap or chain. Preferably waterproof and with a backlight.</li>

  <li><strong>Spare Clothing:</strong> At least one spare jumper, along with hats, gloves,
  goggles, scarf etc.</li>

  <li><strong>Torch:</strong> Absolutely essential - never leave home without one! Complete
  with spare fresh batteries and spare bulb. Check their condition regularly.</li>

  <li><strong>Bivvy Bag:</strong> A large adequate Bivvy Bag in heavy gauge polythene is
  essential. Bin bags are useless, as they give no protection against cold, wet or windy
  weather. Proper <i>Bivvy</i> bags do offer considerable protection from the elements in the
  event of an emergency and can be lifesavers.</li>

  <li><strong>Space Blanket:</strong> Light in weight, occupies 'very little space and can be
  useful in cases of hypothermia when used in conjunction with a Bivvy Bag. Keep it with your
  first-aid kit.</li>

  <li><strong>Money:</strong> Whilst emergency phone calls are free (999), other useful calls
  are not. Carry some 10p coins in your first-aid kit. (mobiles do not work in all
  areas).</li>

  <li><strong>Personal Hygiene:</strong> A small packet of paper hankies can come in very
  handy!</li>

  <li><strong>Pen and Paper:</strong> For emergency notes etc.</li>

  <li><strong>Change of Clothes:</strong> When you are at low ebb after a walk, a change into
  dry, comfortable, preferably warm clothing for the evening is a great morale booster. This
  is normally left on the bus during the walk.</li>
</ul>

<p><strong>Follow the Safety Code:</strong> Be safe on the fells. Be dressed for the day and
the walk. Carry the minimum weight consisting of the maximum items for your personal safety
and comfort. </p>
</div>
